<template>
  <div class="container mx-auto">
    <div class="">
      <div class="space-y-8 mt-12">
        <section class="content">
          <h1 class="text-5xl font-extrabold">
            <span
              class="
                bg-clip-text
                text-transparent
                bg-gradient-to-r
                from-green-400
                to-blue-500
              "
            >
              Страница не найдена (404)
            </span>
          </h1>
        </section>

        <section class="content">
          <p>
            Запрашиваемая вами страница по адресу -
            <span class="text-green-600 font-bold">{{ requestedUrl() }}</span>
            не найдена (или не существует), возможно вы перешли по старой ссылке
            или неправильно ввели адрес запрашиваемой страницы. Перейти на
            <a
              class="tomu-content-link"
              @click.prevent="$router.replace({ name: 'Home' })"
              >главную</a
            >
          </p>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  methods: {
    requestedUrl() {
      return location.href;
    },
  },
};
</script>

<style scoped></style>
